import { EventEmitter, Injectable, Output } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class StatusBarService {
  @Output() onStatus: EventEmitter<string> = new EventEmitter<string>();
  @Output() onAppend: EventEmitter<string> = new EventEmitter<string>();
  @Output() onClear: EventEmitter<any> = new EventEmitter<any>();

  public show() {
  }

  public setStatus(status: string) {
    this.onStatus.emit(status);
  }

  public appendStatus(status: string) {
    this.onAppend.emit(status);
  }

  public clear() {
    this.onClear.emit();
  }
}